import { render, staticRenderFns } from "./userFocus.vue?vue&type=template&id=03a0222e&"
import script from "./userFocus.vue?vue&type=script&lang=js&"
export * from "./userFocus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports